import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-sceco',
  templateUrl: './sceco.component.html',
  styleUrls: ['./sceco.component.scss']
})
export class ScecoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
